module.exports = __webpack_public_path__ + "static/media/Seprater.658eb9c7.svg";